import Vue from 'vue';

import Intersect from '@/shared/lib/directives/intersect';

Vue.directive('intersect', Intersect);
